/**
 * 表计管理（meterManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/meterManagement/modules/ 下弹窗表单页（第 1 组：CardPayModal ~ MeterCycleModalList）
 */
export default {
  '卡充值': 'Card Recharge',
  '用户卡充值': 'Customer Card Recharge',
  '充值记录': 'Recharge Records',
  '用户信息': 'Customer Info',
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '手机号码': 'Mobile Phone',
  '表编号': 'Meter No.',
  '用水单价(元)': 'Water Unit Price (CNY)',
  '单次最大购买金额(元)': 'Max Single Purchase Amount (CNY)',
  '最大囤积金额(元)': 'Max Stockpile Amount (CNY)',
  '用户地址': 'Customer Address',
  '用户缴费信息': 'Customer Payment Info',
  '订单编号': 'Order No.',
  '交易方式': 'Payment Method',
  '营业厅现金': 'Cash at Business Hall',
  '扫码支付': 'QR Code Payment',
  '对公转账': 'Corporate Bank Transfer',
  '计费类型': 'Billing Type',
  '按金额计算': 'By Amount',
  '按吨数计算': 'By Tonnage',
  '用户当前余额(元)': 'Current Balance (CNY)',
  '交易吨数(吨)': 'Transaction Volume (t)',
  '请输入交易吨数': 'Please enter transaction volume',
  '充值金额(元)': 'Recharge Amount (CNY)',
  '请输入充值金额': 'Please enter recharge amount',
  '应收金额(元)': 'Amount Due (CNY)',
  '实际付款(元)': 'Actual Payment (CNY)',
  '请输入实际付款金额': 'Please enter actual payment amount',
  '缴费备注': 'Payment Remarks',
  '请输入缴费备注': 'Please enter payment remarks',
  '用户找零(元)': 'Change (CNY)',
  '充值': 'Recharge',
  '购买金额(元)': 'Purchase Amount (CNY)',
  '缴费途径': 'Payment Channel',
  '购买量(吨)': 'Purchase Volume (t)',
  '订单号': 'Order No.',
  '操作员': 'Operator',
  '充值日期': 'Recharge Date',
  '操作类型': 'Operation Type',
  '共{total}条': 'Total {total} records',
  '交易吨数不能为0，请重新输入！': 'Transaction volume cannot be 0, please re-enter!',
  '充值金额输入有误，请重新输入': 'Invalid recharge amount, please re-enter',
  '实际付款金额输入有误，请重新输入': 'Invalid actual payment amount, please re-enter',
  '写卡成功': 'Card written successfully',
  '写卡失败': 'Card write failed',
  '阀门卡': 'Valve Card',
  '非本公司卡': 'Card not from this company',
  '该用户未制卡，暂不能用卡充值': 'This customer has no card yet, card recharge is unavailable',
  '信息': 'Notice',
  '写卡器连接错误，请确保插件正常运行后，刷新页面重试!': 'Card writer connection error. Make sure the plugin is running properly, then refresh the page and try again!',
  '立即打印票据吗?': 'Print the receipt now?',
  '确认缴费?': 'Confirm payment?',
  '请核对充值金额:{money}元?': 'Please confirm the recharge amount: CNY {money}?',
  '请核对实际付款金额:{money}?': 'Please confirm the actual payment amount: {money}?',
  '充值金额不能为0，请重新输入！': 'Recharge amount cannot be 0, please re-enter!',
  '充值金额超过用户单次购买最大金额{max},请重新输入!': 'Recharge amount exceeds the customer\'s maximum single purchase {max}, please re-enter!',
  '交易金额超过用户最大囤积值{max},请重新输入!': 'Transaction amount exceeds the customer\'s maximum stockpile limit {max}, please re-enter!',
  '实际付款金额小于应收金额，请重新输入实际付款！': 'Actual payment is less than the amount due, please re-enter the actual payment!',
  '姓名': 'Name',
  '输入姓名': 'Enter name',
  '性别': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '职业': 'Occupation',
  '输入职业': 'Enter occupation',
  '籍贯': 'Native Place',
  '输入籍贯': 'Enter native place',
  '身份证号': 'ID Number',
  '输入身份证号': 'Enter ID number',
  '婚姻状况': 'Marital Status',
  '已婚': 'Married',
  '未婚': 'Unmarried',
  '学历': 'Education',
  '输入学历': 'Enter education',
  '手机号': 'Mobile Phone',
  '输入手机号': 'Enter mobile phone',
  '工作单位': 'Workplace',
  '输入工作单位': 'Enter workplace',
  '新建家庭成员': 'Add Family Member',
  '编辑家庭成员': 'Edit Family Member',
  '家庭成员详情': 'Family Member Details',
  '请输入名称': 'Please enter name',
  '家庭成员': 'Family Member',
  '输入姓名查询': 'Enter name to search',
  '将会删除当前家庭成员信息,请慎重操作!': 'The current family member\'s information will be deleted. Please proceed with caution!',
  '确认删除': 'Confirm Deletion',
  '是否删除选中数据?': 'Delete the selected data?',
  '读取身份证信息': 'Read ID Card Info',
  '证件姓名': 'Name on ID',
  '证件号码': 'ID Number',
  '地址': 'Address',
  '名族': 'Ethnicity',
  '出生日期': 'Date of Birth',
  '签发机关': 'Issuing Authority',
  '有效期起始': 'Valid From',
  '有效期终止': 'Valid Until',
  '暂无头像': 'No photo yet',
  '读身份证': 'Read ID Card',
  '人脸核验': 'Face Verification',
  '人像采集': 'Face Capture',
  '摄像头暂未开启': 'Camera is not on',
  '比对': 'Comparison',
  '结果': 'Result',
  '读取身份证信息中，请稍等！': 'Reading ID card info, please wait!',
  '请正对摄像头，正在开启人脸识别。请稍等！': 'Please face the camera. Face recognition is starting, please wait!',
  '请将身份证放置在仪器上识别！': 'Please place the ID card on the device for recognition!',
  '相似度{nResult}%': 'Similarity {nResult}%',
  '识别错误！': 'Recognition failed!',
  '请输入用户编号': 'Please enter customer No.',
  '新表编号': 'New Meter No.',
  '请输入新表编号': 'Please enter new meter No.',
  '旧表编号': 'Old Meter No.',
  '请输入旧表编号': 'Please enter old meter no.',
  '提 交': 'Submit',
  '表类型': 'Meter Type',
  '表安装地址': 'Meter Installation Address',
  '户型': 'Household Type',
  '用户类型': 'Customer Type',
  '营收编号': 'Revenue No.',
  '身份类型': 'Identity Type',
  '自然人': 'Natural Person',
  '企业': 'Enterprise',
  '小区或村庄名': 'Community or Village Name',
  '是否允许缴费': 'Payment Allowed',
  '允许': 'Allowed',
  '不允许': 'Not Allowed',
  '优惠信息': 'Discount Info',
  '表具最新信息': 'Latest Meter Info',
  '最后上报日期': 'Last Report Date',
  '最后上报读数(m³)': 'Last Reported Reading (m³)',
  '开始计费读数': 'Billing Start Reading',
  '请输表开始计费读数': 'Please enter billing start reading',
  '是否整数计费': 'Integer Billing',
  '请选择是否整数计费': 'Select whether to enable integer billing',
  '请选择用户价格名称': 'Please select customer price name',
  '单价:': 'Unit price:',
  '元': 'CNY',
  '元/m³': 'CNY/m³',
  '价格编码': 'Price Code',
  '单价总计': 'Total Unit Price',
  '阶梯数量': 'Number of Tiers',
  '附加费总计': 'Total Surcharges',
  '阶梯计费方式': 'Tiered Billing Method',
  '阶梯起始日期': 'Tier Start Date',
  '一阶水量上限': 'Tier 1 Volume Limit',
  '一阶单价': 'Tier 1 Unit Price',
  '二阶水量上限': 'Tier 2 Volume Limit',
  '二阶单价': 'Tier 2 Unit Price',
  '三阶水量上限': 'Tier 3 Volume Limit',
  '三阶单价': 'Tier 3 Unit Price',
  '四阶水量上限': 'Tier 4 Volume Limit',
  '四阶单价': 'Tier 4 Unit Price',
  '五阶水量上限': 'Tier 5 Volume Limit',
  '五阶单价': 'Tier 5 Unit Price',
  '报警金额': 'Alarm Amount',
  '最大透支金额': 'Max Overdraft Amount',
  '单次最大购买金额': 'Max Single Purchase Amount',
  '最大囤积金额': 'Max Stockpile Amount',
  '磁干扰关阀': 'Magnetic Interference Valve Closure',
  '透支关阀': 'Overdraft Close Valve',
  '欠压关阀': 'Undervoltage Valve Closure',
  '报警关阀': 'Alarm Valve Closure',
  '开启': 'On',
  '不开启': 'Off',
  '请输入表开始计费读数!': 'Please enter the billing start reading!',
  '表开始计费读数最多保留两位小数': 'Billing start reading allows at most 2 decimal places',
  '请选择是否整数计费！': 'Please select whether to enable integer billing!',
  '请选择价格编码！': 'Please select the price code!',
  '平台类型': 'Platform Type',
  '请输入平台类型': 'Please enter platform type',
  '请选择平台类型': 'Please select platform type',
  '应用名称': 'App Name',
  '请输入应用名称': 'Please enter app name',
  '应用ID': 'App ID',
  '请输入APP Secret': 'Please enter APP Secret',
  '请输入应用ID': 'Please enter app ID',
  '请输入移动平台的产品ID': 'Please enter the product ID of the mobile platform',
  '应用Key': 'App Key',
  '请输入APP Key': 'Please enter APP Key',
  '请输入应用Key': 'Please enter app key',
  '产品ID': 'Product ID',
  '请输入产品ID': 'Please enter product ID',
  '请输入masterKey': 'Please enter masterKey',
  '推送地址': 'Push URL',
  '请输入推送地址': 'Please enter push URL',
  '激活状态': 'Activation Status',
  '请输入激活状态': 'Please enter activation status',
  '请输入应用key': 'Please enter app key',
  '请输入正确的产品ID': 'Please enter a valid product ID',
  '上级区域': 'Parent Area',
  '请选择上级区域': 'Please select parent area',
  '区域名称': 'Area Name',
  '请输入区域名称': 'Please enter area name',
  '负责人': 'Person in Charge',
  '请输入负责人': 'Please enter person in charge',
  '负责人电话': 'Person in Charge Phone',
  '请输入负责人电话': 'Please enter person in charge phone',
  '小区备注信息': 'Community Remarks',
  '请输入小区备注信息': 'Please enter community remarks',
  '请输入区域/小区名称!': 'Please enter the area/community name!',
  '高拍仪操作': 'Document Camera Operations',
  '过户协议': 'Transfer Agreement',
  '表具信息': 'Meter Info',
  '计费起始读数': 'Billing Start Reading',
  '运营商': 'Carrier',
  'IMEI号': 'IMEI No.',
  'SIM卡号': 'SIM Card No.',
  '旧用户信息': 'Original Customer Info',
  '类型名称': 'Type Name',
  '用水状态': 'Water Use Status',
  '过户操作': 'Transfer Operation',
  '过户原因描述': 'Transfer Reason Description',
  '请输入过户原因描述': 'Please enter transfer reason description',
  '新用户信息': 'New Customer Info',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户手机号': 'Please enter customer mobile phone',
  '请输入身份证号': 'Please enter ID number',
  '请选择用户价格编码': 'Please select customer price code',
  '用水户型': 'Household Type',
  '请选择用水户型': 'Please select household type',
  '请选择用户类型': 'Please select customer type',
  '请选择身份类型': 'Please select identity type',
  '请选择水表用途': 'Please select water meter purpose',
  '请输入用户姓名！': 'Please enter the customer name!',
  '请输入手机号码': 'Please enter mobile phone number',
  '请输入正确的手机号码': 'Please enter a valid mobile phone number',
  '请输入正确的身份证号': 'Please enter a valid ID number',
  '请选择用户价格编码！': 'Please select the customer price code!',
  '请输入过户原因': 'Please enter transfer reason',
  '过户': 'Transfer',
  '导出': 'Export',
  '导入总条数:': 'Total imported:',
  '成功条数:': 'Succeeded:',
  '模组号': 'Module No.',
  '表口径': 'Meter Caliber',
  '请输入表口径': 'Please enter meter caliber',
  '标准流量': 'Standard Flow',
  '请输入标准流量': 'Please enter standard flow',
  '最大流量': 'Max Flow',
  '请输入最大流量': 'Please enter maximum flow',
  '日报警上限': 'Daily Alarm Upper Limit',
  '请输入日报警上限': 'Please enter daily alarm upper limit',
  '日报警下限': 'Daily Alarm Lower Limit',
  '请输入日报警下限': 'Please enter daily alarm lower limit',
  '强检年限(月)': 'Compulsory Inspection Period (Months)',
  '请输入强检年限月份表示 ': 'Please enter the compulsory inspection period in months ',
  '请输入表口径!': 'Please enter the meter caliber!',
  '轮检记录': 'Routine Inspection Records',
  '检定结果': 'Inspection Result',
  '请选择检定结果': 'Please select inspection result',
  '到检日期': 'Next Inspection Date',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '下载模板': 'Download Template',
  '轮检模板': 'Routine Inspection Template',
  '导入': 'Import',
  '已激活': 'Activated',
  '未激活': 'Not Activated',
  '维修记录': 'Repair Records',
  '维修原因': 'Repair Reason',
  '请选择维修原因': 'Please select repair reason',
  '维修时间': 'Repair Time',
  '维修模板': 'Repair Template',
  '返厂记录': 'Return-to-Factory Records',
  '返厂原因': 'Return-to-Factory Reason',
  '请选择返厂原因': 'Please select return-to-factory reason',
  '返厂时间': 'Return-to-Factory Time',
  '返厂模板': 'Return-to-Factory Template',
  '报废记录': 'Scrapping Records',
  '报废原因': 'Scrapping Reason',
  '请输入报废原因': 'Please enter scrapping reason',
  '报废时间': 'Scrapping Time',
  '报废模板': 'Scrapping Template',
  '表状态': 'Meter Status',
  '出厂日期': 'Production Date',
  '检定日期': 'Inspection Date',
  '添加时间': 'Added At',
  '上次检定日期': 'Last Inspection Date',
  '维修类型': 'Repair Type',
  '返厂状态': 'Return-to-Factory Status',
  '返厂日期': 'Return-to-Factory Date',
  '完成日期': 'Completion Date',
  '新增轮检': 'Add Routine Inspection',
  '新增报废': 'Add Scrapping',
  '新增维修': 'Add Repair',
  '新增返厂': 'Add Return-to-Factory',
  '编辑轮检': 'Edit Routine Inspection',
  '编辑报废': 'Edit Scrapping',
  '编辑维修': 'Edit Repair',
  '编辑返厂': 'Edit Return-to-Factory',
  '轮检详情': 'Routine Inspection Details',
  '报废详情': 'Scrapping Details',
  '维修详情': 'Repair Details',
  '返厂详情': 'Return-to-Factory Details',
  '导出文件': 'Export File',
  '价格名称': 'Price Name',
  '刷新': 'Refresh',

  // ---- 弹窗表单第2组（Cycle/Household/Import/OpenAccount/Particulars/Pay/Priceinfo）----
  '请选择维修时间': 'Please select repair time',
  '请选择维修类型': 'Please select repair type',
  '不换表': 'No Replacement',
  '处理描述': 'Handling Description',
  '请输入处理描述': 'Please enter handling description',
  '编辑成功': 'Updated successfully',
  '请选择返厂状态': 'Please select return-to-factory status',
  '请选择返厂日期': 'Please select return-to-factory date',
  '请选择完成日期': 'Please select completion date',
  '返厂原因描述': 'Return-to-Factory Reason Description',
  '请输入返厂原因描述': 'Please enter return-to-factory reason description',
  '请选择报废时间': 'Please select scrapping time',
  '报废描述': 'Scrapping Description',
  '请输入报废描述': 'Please enter scrapping description',
  '请选择检定日期': 'Please select inspection date',
  '请选择到检日期': 'Please select next inspection date',
  '请输入户型编码': 'Please enter household type code',
  '请输入该类用户的日报警量上限': 'Please enter the daily alarm upper limit for this customer type',
  '请输入该类用户的日报警下限值': 'Please enter the daily alarm lower limit for this customer type',
  '请输入户型编码!': 'Please enter the household type code!',
  '请选择户型名称': 'Please select household type name',
  '该户型编码已存在!': 'This household type code already exists!',
  '该户型名称已存在!': 'This household type name already exists!',
  '按出厂订单编号导入': 'Import by Production Order No.',
  '按Excel导入': 'Import by Excel',
  '出厂订单编号': 'Production Order No.',
  '请输入出厂订单编号': 'Please enter production order no.',
  '请输入表类型': 'Enter meter type',
  '批量导入成功': 'Batch import successful',
  '只支持.xls格式文件！': 'Only .xls files are supported!',
  '消息?': 'Message?',
  '当前订单编号未查询到表具信息,请核对订单编号是否正确！': 'No meter info found for this order no. Please verify the order no.!',
  '表具数量为0，请先查询': 'Meter count is 0, please query first',
  '添加成功,请至【辅助服务--批量任务列表】去查看执行结果': 'Added successfully. Go to [Auxiliary Services -- Batch Task List] to view the execution result',
  '安装经纬度': 'Installation Coordinates',
  '户型ID': 'Household Type ID',
  '请选择用户户型id': 'Please select household type id',
  '请选择用户类型编码': 'Please select customer type code',
  '用户选填信息': 'Optional Customer Info',
  '类型': 'Type',
  '小区名或村庄名': 'Community or Village Name',
  '请输入用户所在小区名或村庄名': 'Please enter community or village name',
  '请选择是否允许缴费': 'Please select whether payment is allowed',
  '请选择优惠信息': 'Please select discount info',
  '请选择类型': 'Please select type',
  '请输入用户编号！': 'Please enter the customer no.!',
  '请在表具信息页面中添加': 'Please add it on the meter info page',
  '用户详细信息': 'Customer Details Info',
  '当前用户状态': 'Current Customer Status',
  '建档日期': 'Filing Date',
  '激活人': 'Activated By',
  '是否人证采集': 'ID Verification Captured',
  '用水协议:': 'Water Agreement:',
  '用户资料:': 'Customer Documents:',
  '协议签名': 'Agreement Signature',
  '实时账户信息': 'Real-time Account Info',
  '结算累计流量(m³)': 'Settled Cumulative Flow (m³)',
  '充值次数': 'Recharge Count',
  '开始计费读数(m³)': 'Billing Start Reading (m³)',
  '最后一次更新日期': 'Last Updated At',
  '电池状态': 'Battery Status',
  '正常': 'Normal',
  '欠压': 'Undervoltage',
  '交易记录': 'Transaction Records',
  '请选择操作类型': 'Please select operation type',
  '上报数据': 'Reported Data',
  '日用量报表': 'Daily Usage Report',
  '命令管理': 'Command Management',
  '调价记录': 'Price Adjustment Records',
  '用户电话': 'Customer Phone',
  '日用量(m³)': 'Daily Usage (m³)',
  '报表日期': 'Report Date',
  '表端时间': 'Meter Time',
  '上报时间': 'Report Time',
  '阀门是否故障': 'Valve Fault',
  '故障': 'Fault',
  '上报累计流量(m³)': 'Reported Total Flow (m³)',
  '电池电压(V)': 'Battery Voltage (V)',
  '日冻结数据': 'Daily Freeze Data',
  '上报方式': 'Report Method',
  '用户名称': 'Customer Name',
  '旧价格信息': 'Old Price Info',
  '新价格信息': 'New Price Info',
  '变更方式': 'Change Method',
  '立即结算': 'Settle Immediately',
  '扣完再启用新价格': 'Enable New Price After Deduction',
  '新价格启用日期': 'New Price Effective Date',
  '命令标识': 'Command ID',
  '命令ID': 'Command ID',
  '通讯状态': 'Communication Status',
  '发送时间': 'Send Time',
  '接收回应时间': 'Response Received At',
  '请输入表编号!': 'Please enter the meter no.!',
  '请输入用户区域id！': 'Please enter customer area ID!',
  '请设置url.list属性!': 'Please set the url.list property!',
  '用户余额(元)': 'Customer Balance (CNY)',
  '累计流量(m³)': 'Cumulative Flow (m³)',
  '按吨数': 'By Tonnage',
  '按金额': 'By Amount',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '请核对充值金额:{amount}元?': 'Please confirm the recharge amount: {amount} CNY?',
  '请核对实际付款金额:{amount}元?': 'Please confirm the actual payment amount: {amount} CNY?',
  '充值余额超过用户囤积金额{max},请重新输入!': 'Recharge balance exceeds the customer\'s maximum stockpile amount {max}, please re-enter!',
  '交易金额超过用户单次购买最大金额{max},请重新输入!': 'Transaction amount exceeds the customer max single purchase amount {max}, please re-enter!',
  '交易余额超过用户最大囤积值{max},请重新输入!': 'Transaction balance exceeds the customer\'s maximum stockpile limit {max}, please re-enter!',
  '交易吨数输入有误，请重新输入': 'Invalid transaction volume, please re-enter',
  '基本水价': 'Basic Water Price',
  '请输入基本水价(两位小数)': 'Please enter basic water price (2 decimals)',
  '阶梯计费起始日期': 'Tiered Billing Start Date',
  '请选择阶梯计费起始日期': 'Please select tiered billing start date',
  '请输入附加费总计': 'Please enter total additional fee',
  '水价总计': 'Total Water Price',
  '请输入单价总计': 'Please enter total unit price',
  '阶梯水价': 'Tiered Water Price',
  '阶梯': 'Tier',
  '水量上限值(m³)': 'Volume Upper Limit (m³)',
  '单价(元)': 'Unit Price (CNY)',
  '合计单价(元)': 'Total Unit Price (CNY)',
  '请输入一阶梯用水量上限': 'Please enter tier-1 volume upper limit',
  '请输入一阶梯用水量价格': 'Please enter tier-1 volume price',
  '请输入二阶梯用水量上限': 'Please enter tier-2 volume upper limit',
  '请输入二阶梯用水量价格': 'Please enter tier-2 volume price',
  '请输入三阶梯用水量上限': 'Please enter tier-3 volume upper limit',
  '请输入三阶梯用水量价格': 'Please enter tier-3 volume price',
  '请输入四阶梯用水量上限': 'Please enter tier-4 volume upper limit',
  '请输入四阶梯用水量价格': 'Please enter tier-4 volume price',
  '请输入五阶梯用水量上限': 'Please enter tier-5 volume upper limit',
  '请输入五阶梯用水量价格': 'Please enter tier-5 volume price',
  '参数': 'Parameter',
  '请输入提示报警金额': 'Please enter alarm amount',
  '请输入最大透支金额': 'Enter max overdraft amount',
  '请输入单次最大购买金额': 'Please enter max single purchase amount',
  '请输入最大囤积金额': 'Enter max stockpile amount',
  '表端计费参数': 'Meter Billing Parameters',
  '磁干扰关阀是否开启': 'Close Valve on Magnetic Interference',
  '透支关阀是否开启': 'Close Valve on Overdraft',
  '欠压关阀是否开启': 'Close Valve on Undervoltage',
  '报警关阀是否开启': 'Close Valve on Alarm',
  '该价格名称费用项目': 'Charge Items of This Price Name',
  '请在下面列表勾选': 'Please check in the list below',
  '项目代码': 'Item Code',
  '请输入价格名称': 'Please enter price name',
  '请输入价格名称!': 'Please enter the price name!',
  '请输入基本单价(两位小数)!': 'Please enter basic unit price (2 decimals)!',
  '基本单价有误(保留两位小数)': 'Invalid basic unit price (2 decimals)',
  '请输入单价总计!': 'Please enter the total unit price!',
  '单价总计有误': 'Invalid total unit price',
  '请选择阶梯数量 总共支持5阶梯!': 'Please select the number of tiers, up to 5 tiers supported!',
  '请选择计费类型！': 'Please select the billing type!',
  '只支持正整数': 'Only positive integers are supported',
  '请输入一阶水量上限': 'Please enter tier-1 volume upper limit',
  '请输入一阶单价': 'Please enter tier-1 unit price',
  '单价有误(保留两位小数)': 'Invalid unit price (2 decimals)',
  '请输入二阶水量上限': 'Please enter tier-2 volume upper limit',
  '请输入二阶单价': 'Please enter tier-2 unit price',
  '请输入三阶水量上限': 'Please enter tier-3 volume upper limit',
  '请输入三阶单价': 'Please enter tier-3 unit price',
  '请输入四阶水量上限': 'Please enter tier-4 volume upper limit',
  '请输入四阶单价': 'Please enter tier-4 unit price',
  '请输入五阶水量上限': 'Please enter tier-5 volume upper limit',
  '请输入五阶单价': 'Please enter tier-5 unit price',
  '请选择禁用状态!': 'Please select the disabled status!',
  '水费总计不能超过600!': 'Total water fee cannot exceed 600!',
  '不能超过999999!': 'Cannot exceed 999999!',
  '该价格编码已存在!': 'This price code already exists!',
  '未开始计费': 'Billing Not Started',
  '已开始计费': 'Billing Started',
  '您的手机号码格式不正确!': 'Invalid mobile phone number format!',
  '应用已存在!': 'This app already exists!',
  '应用ID已存在!': 'This app ID already exists!',
  'masterKey已存在!': 'This masterKey already exists!',
  '产品ID已存在!': 'This product ID already exists!',
  '应用key已存在!': 'This app key already exists!',
  '该表口径已存在!': 'This meter caliber already exists!',

  // ---- 弹窗表单第2组补充 ----
  '新增成功': 'Added successfully',
  '请输入表编号': 'Please enter meter No.',
  '请选择操作员': 'Please select operator',
  '户型名称': 'Household Type Name',
  '户型编码': 'Household Type Code',
  '日报警下限值': 'Daily Alarm Lower Limit',
  '日报警量上限': 'Daily Alarm Upper Limit',
  '请输入户型名称': 'Please enter household type name',
  '上传文件': 'Upload File',
  '任务名称': 'Task Name',
  '批量导入': 'Batch Import',
  '批量报装模板': 'Batch Installation Template',
  '描述': 'Description',
  '表具总数': 'Total Meters',
  '请先选择上传文件': 'Please select a file to upload first',
  '请输入任务名称': 'Please enter task name',
  '查看任务{name}的执行结果': 'View execution result of task {name}',
  '请选择表口径': 'Please select meter caliber',
  '请选择表类型': 'Select meter type',
  '选择导入文件': 'Select File to Import',
  '类型编码': 'Type Code',
  '请输入用户营收编号': 'Please enter customer revenue No.',
  '上传': 'Upload',
  '价格信息': 'Price Info',
  '已制卡': 'Card Issued',
  '未制卡': 'Card Not Issued',
  '当前余额(元)': 'Current Balance (CNY)',
  '文件下载失败': 'File download failed',
  '是否制卡': 'Card Issued',
  '激活时间': 'Activation Time',
  '阀门状态': 'Valve Status',
  '缴费': 'Payment',
  '单价（元）': 'Unit Price (CNY)',
  '按量': 'By Volume',
  '收取方式': 'Collection Method',
  '水费类型': 'Water Fee Type',
  '禁用状态': 'Disabled Status',
  '请输入报警金额！': 'Please enter the alarm amount!',
  '请输入最大囤积金额！': 'Please enter the max stockpile amount!',
  '请输入最大购买金额！': 'Please enter the max purchase amount!',
  '请输入最大透支金额！': 'Please enter the max overdraft amount!',
  '请选择': 'Please select',
  '请选择报警关阀是否开启！': 'Please select whether to close valve on alarm!',
  '请选择欠压关阀是否开启！': 'Please select whether to close valve on undervoltage!',
  '请选择磁干扰关阀是否开启！': 'Please select whether to close valve on magnetic interference!',
  '请选择计费方式': 'Please select billing method',
  '请选择计费类型': 'Please select billing type',
  '请选择透支关阀是否开启！': 'Please select whether to close valve on overdraft!',
  '请选择阶梯数量': 'Please select the number of tiers',
  '请选择阶梯计费方式！': 'Please select the tiered billing method!',
  '请选择阶梯计费起始日期！': 'Please select the tiered billing start date!',
  '项目名称': 'Item Name',
  '未知': 'Unknown',
  // ---- 第 3 组：MeterReplenishmentModal ~ MeterUserinfoModal ----
  '(按Excel)': '(By Excel)',
  '(按区域)': '(By Area)',
  '上报平台没有回应数': 'No-Response Count of Reports',
  '上报月份': 'Report Month',
  '上期余额(元)': 'Previous Balance (CNY)',
  '上期累计(m³)': 'Previous Cumulative (m³)',
  '下一步': 'Next',
  '不上传数据': 'No Data Upload',
  '不动产权号/营业执照号': 'Property Right No. / Business License No.',
  '交易余额超过用户最大囤积值{amount},请重新输入!': 'Transaction balance exceeds the customer\'s maximum stockpile limit {amount}, please re-enter!',
  '交易吨数(m³)': 'Transaction Volume (m³)',
  '交易吨数有误，请重新输入': 'Invalid transaction volume, please re-enter',
  '交易时间': 'Transaction Time',
  '交易金额超过用户单次购买最大金额{amount},请重新输入!': 'Transaction amount exceeds the maximum single purchase {amount} of the customer, please re-enter!',
  '人证识别': 'ID-Face Verification',
  '优惠水量': 'Free Water Quota',
  '优惠百分比': 'Discount Percentage',
  '优惠类型': 'Discount Type',
  '你确定要恢复该条记录吗?': 'Are you sure to restore this record?',
  '你确定要撤销该条记录吗?': 'Are you sure you want to revoke this record?',
  '前一步': 'Previous',
  '原用户手机号': 'Original Customer Mobile Phone',
  '原身份证号': 'Original ID Number',
  '发送状态': 'Send Status',
  '启用日期': 'Effective Date',
  '周期性换表': 'Periodic Meter Replacement',
  '命令服务队列': 'Command Service Queue',
  '命令类型': 'Command Type',
  '命令详情': 'Command Details',
  '地址信息': 'Address Info',
  '基表爆裂': 'Base Meter Burst',
  '基表问题': 'Base Meter Problem',
  '存储故障': 'Storage Fault',
  '存储状态': 'Storage Status',
  '安装纬度': 'Installation Latitude',
  '安装经度': 'Installation Longitude',
  '完成': 'Finish',
  '实际补水金额(元)': 'Actual Water Supplement Amount (CNY)',
  '实际退费金额(元)': 'Actual Refund Amount (CNY)',
  '实际退费金额大于用户剩余金额，请重新输入交易吨数！': 'Actual refund amount exceeds the remaining balance of the customer, please re-enter the transaction volume!',
  '当前价格信息': 'Current Price Info',
  '恢复撤销': 'Restore Reversal',
  '户号绑定': 'Meter No. Binding',
  '所属区域': 'Area',
  '所属区域名称': 'Area Name',
  '所选区域': 'Selected Area',
  '扣费记录': 'Deduction Records',
  '扫描用户纸质资料': 'Scan Customer Paper Documents',
  '批量方式': 'Batch Method',
  '批量调价模板': 'Batch Price Adjustment Template',
  '按区域导入': 'Import by Area',
  '换表原因': 'Meter Replacement Reason',
  '换表原因描述': 'Meter Replacement Reason Description',
  '换表原因类型': 'Meter Replacement Reason Type',
  '换表后实时金额': 'Real-time amount after replacement',
  '换表成功': 'Meter replaced successfully',
  '换表操作': 'Meter Replacement Operation',
  '换表结算余额(元)': 'Balance After Replacement Settlement (CNY)',
  '换表记录': 'Meter Replacement Records',
  '撤销': 'Revoke',
  '操作人': 'Operated By',
  '操作时间': 'Operation Time',
  '故障换表': 'Faulty Meter Replacement',
  '新用户姓名': 'New Customer Name',
  '新表具信息': 'New Meter Info',
  '新表开始计费读数': 'New Meter Billing Start Reading',
  '新表开始计费读数(m³)': 'New Meter Billing Start Reading (m³)',
  '新表开始计费读数最多保留两位小数': 'New meter billing start reading allows at most 2 decimal places',
  '新表表端累计读数(m³)': 'New Meter Cumulative Reading (m³)',
  '新表起始计费读数小于新表最新上报累计用量，{amount}(m³)会进行计费，请确认': 'The billing start reading of the new meter is less than its latest reported cumulative usage; {amount} (m³) will be billed, please confirm',
  '新表起始读数': 'New Meter Start Reading',
  '新身份证号': 'New ID Number',
  '旧用户姓名': 'Original Customer Name',
  '旧表余额(元)': 'Old Meter Balance (CNY)',
  '旧表具信息': 'Old Meter Info',
  '旧表机械读数(m³)': 'Old Meter Mechanical Reading (m³)',
  '旧表累积量(m³)': 'Old Meter Cumulative Usage (m³)',
  '是否以旧表机械读数结算': 'Settle by Old Meter Mechanical Reading',
  '是否确认换表': 'Confirm meter replacement?',
  '最后上报读数': 'Last Reported Reading',
  '最近更新日期': 'Last Updated At',
  '有': 'Yes',
  '末次上报日期': 'Last Report Date',
  '末次上报结算余额(元)': 'Last Reported Settlement Balance (CNY)',
  '末次上报结算流量(m³)': 'Last Reported Settlement Flow (m³)',
  '末次上报读数(m³)': 'Last Reported Reading (m³)',
  '本期余额(元)': 'Current Balance (CNY)',
  '本期使用(m³)': 'Current Usage (m³)',
  '本期累计(m³)': 'Current Cumulative (m³)',
  '查询起止时间': 'Query Time Range',
  '水表厂商': 'Water Meter Manufacturer',
  '水表无反应（黑屏，无法激活）': 'Water meter unresponsive (black screen, cannot activate)',
  '添加表具': 'Add Meter',
  '激活': 'Activate',
  '点击选择区域': 'Click to select area',
  '用户价格编码': 'Customer Price Code',
  '用户优惠信息': 'Customer Discount Info',
  '用户区域Id': 'Customer Area ID',
  '用户唯一地址标识': 'Customer Unique Address Identifier',
  '用户开户时表读数': 'Meter Reading at Account Opening',
  '用户开户时阀门开关状态 0无动作 1 开阀 2 关阀': 'Valve Status at Account Opening (0 none, 1 open, 2 close)',
  '用户户型信息Id': 'Customer Household Type ID',
  '用户所在区域名称': 'Customer Area Name',
  '用户所在小区名或村庄名': 'Customer Community or Village Name',
  '用户手机号': 'Customer Mobile Phone',
  '用户是否允许缴费 0不允许 1允许': 'Payment Allowed (0 no, 1 yes)',
  '用户用水状态 0未开始计费 1已开始计费': 'Water Use Status (0 billing not started, 1 billing started)',
  '用户类型编码': 'Customer Type Code',
  '用户营收编号 一般和用户编号一致': 'Customer Revenue No. (usually same as customer no.)',
  '用户补水信息': 'Water Supplement Info',
  '用户评价': 'Customer Rating',
  '用户资料': 'Customer Documents',
  '用户退水信息': 'Water Refund Info',
  '用来标识是自然人 还是 企业': 'Indicates natural person or enterprise',
  '用水': 'Water Use',
  '用水协议': 'Water Use Agreement',
  '电子问题': 'Electronic Problem',
  '电话号码': 'Phone Number',
  '磁干扰': 'Magnetic Interference',
  '类型代码': 'Type Code',
  '累计用量(m³)': 'Cumulative Usage (m³)',
  '缺电': 'Power Shortage',
  '补水': 'Water Supplement',
  '补水余额超过用户囤积金额{amount},请重新输入!': 'Water supplement balance exceeds the customer\'s maximum stockpile amount {amount}, please re-enter!',
  '补水备注': 'Water Supplement Remarks',
  '补水记录': 'Water Supplement Records',
  '补水量(吨)': 'Water Supplement Volume (t)',
  '补水金额(元)': 'Water Supplement Amount (CNY)',
  '补水金额不能为0，请重新输入！': 'Water supplement amount cannot be 0, please re-enter!',
  '补水金额超过用户单次购买最大金额{amount},请重新输入!': 'Water supplement amount exceeds the maximum single purchase {amount} of the customer, please re-enter!',
  '补水金额输入有误，请重新输入': 'Invalid water supplement amount, please re-enter',
  '表端上报数据次数': 'Meter Report Count',
  '表计费起始读数(m³)': 'Meter Billing Start Reading (m³)',
  '表起始读数': 'Meter Start Reading',
  '计费时间': 'Billing Time',
  '计费起始读数(m³)': 'Billing Start Reading (m³)',
  '计量问题': 'Metering Problem',
  '该用户已激活，不能重新选择表号！': 'This customer has been activated, the meter no. cannot be re-selected!',
  '该用户编号已存在!': 'This customer no. already exists!',
  '该类型代码已存在!': 'This type code already exists!',
  '该类型名称已存在!': 'This type name already exists!',
  '该设备剩余金额为0或还没使用过，不能进行退费！': 'The device balance is 0 or has never been used, refund is unavailable!',
  '请先上传excel文件': 'Please upload an Excel file first',
  '请先选择区域': 'Please select an area first',
  '请在表具信息页面中添加该表编号！': 'Please add this meter no. on the meter info page!',
  '请开户后在进行激活！': 'Please open an account before activation!',
  '请输入remark': 'Please enter remark',
  '请输入不动产权号/营业执照号': 'Please enter property right no. / business license no.',
  '请输入优惠类型': 'Please enter discount type',
  '请输入备注说明': 'Please enter remark',
  '请输入实际退费金额': 'Please enter actual refund amount',
  '请输入换表原因描述': 'Please enter meter replacement reason description',
  '请输入换表后实时金额': 'Please enter real-time amount after replacement',
  '请输入新表开始计费读数!': 'Please enter the new meter billing start reading!',
  '请输入旧表机械读数': 'Please enter old meter mechanical reading',
  '请输入旧表机械读数！': 'Please enter the old meter mechanical reading!',
  '请输入正确的换表后实时金额': 'Please enter a valid real-time amount after replacement',
  '请输入水表厂商': 'Please enter water meter manufacturer',
  '请输入水表安装地址': 'Please enter meter installation address',
  '请输入水表安装纬度': 'Please enter meter installation latitude',
  '请输入水表安装经度': 'Please enter meter installation longitude',
  '请输入用户价格编码': 'Please enter customer price code',
  '请输入用户优惠信息': 'Please enter customer discount info',
  '请输入用户区域Id': 'Please enter customer area ID',
  '请输入用户唯一地址标识': 'Please enter customer unique address identifier',
  '请输入用户地址': 'Please enter customer address',
  '请输入用户开户时表读数': 'Please enter meter reading at account opening',
  '请输入用户开户时阀门开关状态 0无动作 1 开阀 2 关阀': 'Please enter valve status at account opening (0 none, 1 open, 2 close)',
  '请输入用户户型信息Id': 'Please enter customer household type ID',
  '请输入用户所在区域名称': 'Please enter customer area name',
  '请输入用户是否允许缴费 0不允许 1允许': 'Please enter whether payment is allowed (0 no, 1 yes)',
  '请输入用户用水状态 0未开始计费 1已开始计费': 'Please enter water use status (0 billing not started, 1 billing started)',
  '请输入用户类型编码': 'Please enter customer type code',
  '请输入用户营收编号 一般和用户编号一致': 'Please enter customer revenue no. (usually same as customer no.)',
  '请输入用户表起始读数': 'Please enter customer meter start reading',
  '请输入用来标识是自然人 还是 企业': 'Please enter natural person or enterprise',
  '请输入类型名称': 'Please enter type name',
  '请输入类型编码': 'Please enter type code',
  '请输入类型编码!': 'Please enter the type code!',
  '请输入补水备注': 'Please enter water supplement remarks',
  '请输入补水金额': 'Please enter water supplement amount',
  '请输入表类型代码 如 MN100': 'Please enter meter type code, e.g. MN100',
  '请输入表类型代码 如 MN100!': 'Please enter the meter type code, e.g. MN100!',
  '请输入表类型代码简称': 'Please enter meter type code abbreviation',
  '请输入表计费起始读数！': 'Please enter the meter billing start reading!',
  '请输入该类用户优惠水量': 'Please enter free water quota for this customer type',
  '请输入该类用户优惠百分比': 'Please enter discount percentage for this customer type',
  '请输入退费备注': 'Please enter refund remarks',
  '请输入退费金额': 'Please enter refund amount',
  '请选择价格信息!': 'Please select the price info!',
  '请选择价格启用日期!': 'Please select the price effective date!',
  '请选择区域': 'Please select area',
  '请选择区域名称': 'Please select area name',
  '请选择变更方式!': 'Please select the change method!',
  '请选择启用日期': 'Please select effective date',
  '请选择换表原因': 'Please select meter replacement reason',
  '请选择换表原因类型': 'Please select meter replacement reason type',
  '请选择新价格信息!': 'Please select the new price info!',
  '请选择新表口径': 'Please select new meter caliber',
  '请选择新表编号': 'Please select new meter no.',
  '请选择旧价格信息!': 'Please select the old price info!',
  '请选择是否以旧表机械读数结算': 'Select whether to settle by old meter mechanical reading',
  '请选择是否以旧表机械读数结算！': 'Please select whether to settle by old meter mechanical reading!',
  '请选择类型名称': 'Please select type name',
  '请选择表类型名称': 'Please select the type name',
  '请选择表编号': 'Please select meter no.',
  '读二代身份证': 'Read ID Card',
  '账户余额(元)': 'Account Balance (CNY)',
  '输入表编号模糊查询': 'Enter meter no. to search',
  '过户记录': 'Ownership Transfer Records',
  '退费': 'Refund',
  '退费备注': 'Refund Remarks',
  '退费记录': 'Refund Records',
  '退费金额(元)': 'Refund Amount (CNY)',
  '退费金额不能为0，请重新输入！': 'Refund amount cannot be 0, please re-enter!',
  '退费金额输入有误，请重新输入': 'Invalid refund amount, please re-enter',
  '选择': 'Select',
  '金额变动(元)': 'Amount Change (CNY)',
  '阀门故障': 'Valve Fault',
  '需要立即激活该用户吗?': 'Activate this customer immediately?',

  // 第二轮补翻（覆盖率终检发现的缺失 key）
  '(按量的80%收取)': 'Charged at 80% of volume',
  '一键激活模板': 'One-Click Activation Template',
  '上期结余': 'Previous Balance',
  '上次余额': 'Previous Balance',
  '下载': 'Download',
  '下载一键激活模板': 'Download One-Click Activation Template',
  '下载批量删除模板': 'Download Batch Deletion Template',
  '下载批量建档模板': 'Download Batch Filing Template',
  '下载批量报装模板': 'Download Batch Installation Template',
  '下载批量更新册号模板': 'Download Batch Register No. Update Template',
  '下载批量更新经纬度模板': 'Download Batch Latitude/Longitude Update Template',
  '下载批量激活模板': 'Download Batch Activation Template',
  '不支持复制': 'Copy Not Supported',
  '不满意': 'Dissatisfied',
  '交易金额(元)': 'Transaction Amount (CNY)',
  '交易金额(大写)': 'Transaction Amount (in Words)',
  '任务名称模糊查询': 'Search by task name',
  '任务总记录数': 'Total Task Records',
  '任务操作类型': 'Task Operation Type',
  '任务状态': 'Task Status',
  '任务类型': 'Task Type',
  '住户类型': 'Household Type',
  '余额': 'Balance',
  '使用状态': 'Usage Status',
  '保存': 'Save',
  '保存成功!': 'Saved successfully!',
  '修改人': 'Modified By',
  '修改时间': 'Modified At',
  '停表后，该表用户信息将不在系统内显示，只有报停恢复后，才恢复正常使用。确定停表？': 'After suspension, the customer info of this meter will no longer be shown in the system; normal use resumes only after the suspension is lifted. Suspend this meter?',
  '全生命周期': 'Full Life Cycle',
  '册号': 'Register No.',
  '净水费': 'Clean Water Fee',
  '创建任务': 'Create Task',
  '创建成功': 'Created successfully',
  '删除成功!': 'Deleted successfully!',
  '删除用户': 'Delete Customer',
  '制卡': 'Card Issuing',
  '区域': 'Area',
  '区域ID': 'Area ID',
  '协议': 'Agreement',
  '协议签名:': 'Agreement Signature:',
  '协议附件:': 'Agreement Attachment:',
  '单价': 'Unit Price',
  '单价(元/m³)': 'Unit Price (CNY/m³)',
  '单价/m³': 'Unit Price /m³',
  '卡操作': 'Card Operation',
  '厂商代码': 'Manufacturer Code',
  '双鸭山农场有限公司自来水收费票据': 'Shuangyashan Farm Co., Ltd. Water Fee Receipt',
  '发送协议': 'Send Agreement',
  '发送协议中，请在高拍仪上签字！': 'Sending agreement, please sign on the document camera!',
  '发送评价': 'Send Rating',
  '发送评价中，请稍等！': 'Sending rating, please wait!',
  '取消选择': 'Deselect',
  '只': 'pcs',
  '只支持.xls,.xlsx格式文件！': 'Only .xls and .xlsx files are supported!',
  '合同名称': 'Contract Name',
  '合同地址': 'Contract Address',
  '命令添加成功': 'Command added successfully',
  '和静县清泉水利综合服务有限责任公司': 'Hejing County Qingquan Water Conservancy Comprehensive Service Co., Ltd.',
  '商户': 'Merchant',
  '固定电话': 'Fixed-line Phone',
  '在平台中的用户管理信息、表具信息、实时数据信息、上报信息的数据，请慎重操作!': 'Please operate with caution: this covers customer management, meter, real-time data and reported data on the platform!',
  '在库表具数量': 'Meters in Stock',
  '基本信息': 'Basic Information',
  '基本水价(元)': 'Basic Water Price (CNY)',
  '复制': 'Copy',
  '复制成功': 'Copied successfully',
  '大兴水厂用户缴费收据': 'Daxing Water Plant Customer Payment Receipt',
  '大写金额': 'Amount in Words',
  '安装数量': 'Installed Quantity',
  '宗教信仰': 'Religion',
  '实收金额': 'Amount Received',
  '实收金额：': 'Amount Received:',
  '家庭住址': 'Home Address',
  '将会删除': 'Will be deleted',
  '将会删除当前用户合同,请慎重操作!': 'The current customer contract will be deleted, please operate with caution!',
  '将会删除当前租户信息,请慎重操作!': 'The current tenant info will be deleted, please operate with caution!',
  '展开': 'Expand',
  '山阴县自来水公司销售凭证': 'Shanyin County Water Company Sales Voucher',
  '已建档': 'Filed',
  '应收金额': 'Amount Due',
  '建档数': 'Filed Count',
  '建档时间': 'Filing Time',
  '建档状态': 'Filing Status',
  '开启扫描': 'Start Scanning',
  '开始时间': 'Start Time',
  '开户': 'Account Opening',
  '当前选择：': 'Currently selected:',
  '待执行': 'Pending',
  '微信对账': 'WeChat Reconciliation',
  '总计': 'Total',
  '打印': 'Print',
  '打印员:': 'Printed by:',
  '打印日期：': 'Print Date:',
  '打印时间:': 'Print Time:',
  '打印预览': 'Print Preview',
  '执行中': 'Running',
  '执行完成': 'Completed',
  '执行成功记录数': 'Successful Records',
  '扫描用户资料': 'Scan Customer Documents',
  '批量一键激活': 'Batch One-Click Activation',
  '批量删除': 'Batch Delete',
  '批量命令': 'Batch Command',
  '批量建档': 'Batch Filing',
  '批量建档模板': 'Batch Filing Template',
  '批量报装': 'Batch Installation',
  '批量更新册号': 'Batch Update Register No.',
  '批量更新出厂日期': 'Batch Update Production Date',
  '批量更新经纬度': 'Batch Update Latitude/Longitude',
  '批量更新经纬度模板': 'Batch Latitude/Longitude Update Template',
  '批量激活': 'Batch Activation',
  '批量激活模板': 'Batch Activation Template',
  '批量调价': 'Batch Price Adjustment',
  '折叠': 'Collapse',
  '报停': 'Suspension',
  '报停成功': 'Suspension successful',
  '换表': 'Meter Replacement',
  '操作员：': 'Operator:',
  '操作失败': 'Operation failed',
  '操作成功': 'Operation successful',
  '收到未匹配的消息：': 'Received unmatched message:',
  '收费员:': 'Collector:',
  '收费员姓名：': 'Collector Name:',
  '收费对账': 'Payment Reconciliation',
  '收费项目': 'Charge Item',
  '收起': 'Collapse',
  '文件名称': 'File Name',
  '新增用户信息': 'Add Customer Info',
  '新建档案': 'New Archive',
  '新建用户合同': 'New Customer Contract',
  '新建租户信息': 'New Tenant Info',
  '无': 'None',
  '无图片': 'No Image',
  '无文件': 'No File',
  '日期：': 'Date:',
  '是否带阀': 'With Valve',
  '是否报停': 'Suspended',
  '是否销户': 'Cancelled',
  '暂无评价': 'No Ratings Yet',
  '更新时间': 'Updated At',
  '最多扫描20张，如果要继续扫描请删除之前的图片！': 'Up to 20 scans; delete previous images to continue scanning!',
  '未建档': 'Not Filed',
  '未收到签名图片数据': 'No signature image data received',
  '未查询到数据！': 'No data found!',
  '未知错误': 'Unknown Error',
  '未解析到签名图片': 'Signature image not parsed',
  '本期结余': 'Current Period Balance',
  '本次购买量(吨)': 'Purchase Volume (t)',
  '本次购买金额(元)': 'Purchase Amount (CNY)',
  '查看结果': 'View Results',
  '查询建档时间': 'Search by filing time',
  '查询激活时间': 'Search by activation time',
  '正在生成协议，请稍等！': 'Generating agreement, please wait!',
  '民族': 'Ethnicity',
  '水价总计(元)': 'Total Water Price (CNY)',
  '水表充值二维码': 'Water Meter Recharge QR Code',
  '水表用途': 'Water Meter Purpose',
  '水费单价(元/m³)': 'Water Fee Unit Price (CNY/m³)',
  '水量(m³)': 'Water Volume (m³)',
  '污水处理费(元/m³)': 'Sewage Treatment Fee (CNY/m³)',
  '汤原农场自来水水司收费票据': 'Tangyuan Farm Water Company Fee Receipt',
  '测试附件': 'Test Attachment',
  '添加': 'Add',
  '添加下级': 'Add Child',
  '满意': 'Satisfied',
  '生成二维码失败': 'Failed to generate QR code',
  '生成协议失败：': 'Failed to generate agreement:',
  '生成协议失败：未返回PDF数据': 'Failed to generate agreement: no PDF data returned',
  '生成协议异常：': 'Error generating agreement:',
  '生日': 'Birthday',
  '用户价格名称': 'Customer Price Name',
  '用户合同': 'Customer Contract',
  '用户合同详情': 'Customer Contract Details',
  '用户名': 'Username',
  '用户地址模糊查询': 'Search by customer address',
  '用户姓名模糊查询': 'Search by customer name',
  '用户姓名：': 'Customer Name:',
  '用户手机号模糊查询': 'Search by customer mobile phone',
  '用户报停': 'Customer Suspension',
  '用户换表': 'Customer Meter Replacement',
  '用户操作记录': 'Customer Operation Records',
  '用户档案': 'Customer Archive',
  '用户状态': 'Customer Status',
  '用户纸质资料': 'Customer Paper Documents',
  '用户编号模糊查询': 'Search by customer no.',
  '用户编号：': 'Customer No.:',
  '用户编码': 'Customer Code',
  '用户评价信息': 'Customer Rating Info',
  '用户详情': 'Customer Details',
  '用户调价': 'Customer Price Adjustment',
  '用户过户': 'Customer Ownership Transfer',
  '用户销户': 'Customer Account Cancellation',
  '用水性质': 'Water Use Category',
  '电签失败！请联系管理员': 'E-sign failed! Please contact the administrator',
  '电签失败！请联系管理员并提供错误代码 :': 'E-sign failed! Please contact the administrator and provide the error code:',
  '电签失败！请联系管理员并提供错误代码:': 'E-sign failed! Please contact the administrator and provide the error code:',
  '租客': 'Renter',
  '租户': 'Tenant',
  '租户信息': 'Tenant Info',
  '租户信息详情': 'Tenant Info Details',
  '结束时间': 'End Time',
  '综合单价/m³': 'Comprehensive Unit Price /m³',
  '编辑用户合同': 'Edit Customer Contract',
  '编辑租户信息': 'Edit Tenant Info',
  '自定义列': 'Custom Columns',
  '自来水水司收费票据': 'Water Company Fee Receipt',
  '表全生命周期': 'Meter Full Life Cycle',
  '表具明细': 'Meter Details',
  '表具统计': 'Meter Statistics',
  '表口径统计': 'Meter Caliber Statistics',
  '表总数量': 'Total Meters',
  '表类型代码': 'Meter Type Code',
  '表类型名称': 'Meter Type Name',
  '表编号模糊查询': 'Search by meter no.',
  '记录原来用户价格编码': 'Record Original Customer Price Code',
  '记录原来用户优惠信息': 'Record Original Customer Discount Info',
  '记录原来用户开户时表读数': 'Record Original Meter Reading at Account Opening',
  '记录原来用户开户时阀门开关状态 0无动作 1 开阀 2 关阀': 'Record Original Valve Status at Account Opening (0: none, 1: open, 2: close)',
  '记录原来用户户型信息Id': 'Record Original Household Info ID',
  '记录原来用户手机号': 'Record Original Customer Mobile Phone',
  '记录原来用户类型编码': 'Record Original Customer Type Code',
  '记录原来用户表计费起始读数': 'Record Original Billing Start Reading',
  '记录原来用来标识是自然人 还是 企业': 'Record Original Flag: Natural Person or Enterprise',
  '记录原来身份证号': 'Record Original ID Card No.',
  '证像采集': 'ID Photo Capture',
  '评价': 'Evaluation',
  '评价中...': 'Rating...',
  '评价错误！': 'Rating error!',
  '该表已建档不能删除!': 'This meter is filed and cannot be deleted!',
  '请上传合同附件': 'Please upload the contract attachment',
  '请先点击选中上级区域！': 'Please select a parent area first!',
  '请先选择一个区域!': 'Please select an area first!',
  '请先选择要评价的员工！': 'Please select an employee to rate first!',
  '请将资料放置摄像头下，正在开启扫描。请稍等！': 'Please place documents under the camera; scanning is starting. Please wait!',
  '请点击选择要修改区域!': 'Please click to select the area to modify!',
  '请等待任务执行成功后查询执行结果!': 'Please wait for the task to finish before querying the results!',
  '请输入IMEI号': 'Please enter IMEI No.',
  '请输入SIM卡号': 'Please enter SIM No.',
  '请输入价格名称模糊搜索': 'Enter price name to search',
  '请输入册号': 'Please enter register No.',
  '请输入创建时间': 'Please enter creation time',
  '请输入区域/小区名称': 'Please enter area/community name',
  '请输入区域编码!': 'Please enter area code!',
  '请输入厂商代码': 'Please enter manufacturer code',
  '请输入合同名称': 'Please enter contract name',
  '请输入正确的册号!': 'Please enter a valid register No.!',
  '请输入正确的表编号!': 'Please enter a valid meter no.!',
  '请输入正确的表编号(12位数字)': 'Please enter a valid meter no. (12 digits)',
  '请输入正确的表编号(14位数字)': 'Please enter a valid meter no. (14 digits)',
  '请输入正确的表编号(3378开头14位数字)': 'Please enter a valid meter no. (14 digits starting with 3378)',
  '请输入用户价格名称': 'Please enter customer price name',
  '请输入用户地址模糊查询': 'Enter customer address to search',
  '请输入用户姓名模糊查询': 'Enter customer name to search',
  '请输入用户手机号模糊查询': 'Enter customer mobile phone to search',
  '请输入用户编号模糊查询': 'Enter customer No. to search',
  '请输入用户编码': 'Please enter customer code',
  '请输入表类型代码': 'Please enter meter type code',
  '请输入表类型名称': 'Please enter meter type name',
  '请输入表编号模糊查询': 'Enter meter No. to search',
  '请输入记录原来用户价格编码': 'Please enter original customer price code',
  '请输入记录原来用户优惠信息': 'Please enter original customer discount info',
  '请输入记录原来用户开户时表读数': 'Please enter original meter reading at account opening',
  '请输入记录原来用户开户时阀门开关状态 0无动作 1 开阀 2 关阀': 'Please enter original valve status at account opening (0: none, 1: open, 2: close)',
  '请输入记录原来用户户型信息Id': 'Please enter original household info ID',
  '请输入记录原来用户手机号': 'Please enter original customer mobile phone',
  '请输入记录原来用户类型编码': 'Please enter original customer type code',
  '请输入记录原来用户表计费起始读数': 'Please enter original billing start reading',
  '请输入记录原来用来标识是自然人 还是 企业': 'Please enter original flag: natural person or enterprise',
  '请输入记录原来身份证号': 'Please enter original ID card no.',
  '请输入负责人!': 'Please enter the person in charge!',
  '请输入负责人名称': 'Please enter person in charge name',
  '请输入负责人手机号': 'Please enter person in charge mobile phone',
  '请选择任务类型': 'Please select task type',
  '请选择使用状态': 'Please select usage status',
  '请选择出厂日期': 'Please select production date',
  '请选择合同开始时间': 'Please select contract start time',
  '请选择合同结束时间': 'Please select contract end time',
  '请选择开始时间': 'Please select start time',
  '请选择是否制卡': 'Please select whether to issue a card',
  '请选择是否带阀': 'Please select whether with valve',
  '请选择是否证像采集': 'Please select whether to capture ID photo',
  '请选择水表当前状态！': 'Please select the current water meter status!',
  '请选择用户状态': 'Please select customer status',
  '请选择禁用状态': 'Please select disabled status',
  '请选择结束时间': 'Please select end time',
  '请选择表口径！': 'Please select meter caliber!',
  '请选择表类型！': 'Please select meter type!',
  '请选择评价员工': 'Please select employee to rate',
  '请选择运营商': 'Select carrier',
  '调价': 'Price Adjustment',
  '账户余额': 'Account Balance',
  '购买吨数': 'Purchase Tonnage',
  '购水量/m³': 'Water Purchase Volume /m³',
  '输入合同名称': 'Enter contract name',
  '输入合同名称查询': 'Enter contract name to search',
  '输入合同地址': 'Enter contract address',
  '输入固定电话': 'Enter fixed-line phone',
  '输入备注': 'Enter remarks',
  '输入宗教信仰': 'Enter religion',
  '输入家庭住址': 'Enter home address',
  '输入民族': 'Enter ethnicity',
  '退水': 'Water Refund',
  '选择评价员工': 'Select employee to rate',
  '重点关注': 'Key Attention',
  '金额': 'Amount',
  '销户后，该表信息所有将在系统内消失，无法正常使用。确定销户？': 'After account cancellation, all info of this meter will disappear from the system and it can no longer be used. Cancel the account?',
  '销户成功': 'Account cancelled successfully',
  '附件': 'Attachment',
  '非常满意': 'Very Satisfied',
  '项目': 'Item',
  '额敏县众诚供排水有限责任公司销售凭证': 'Emin County Zhongcheng Water Supply and Drainage Co., Ltd. Sales Voucher',
}
